module.exports = __webpack_public_path__ + "img/Crew-4.036d2013.png";